import { render, staticRenderFns } from "./RiskWarning.vue?vue&type=template&id=550b7598&scoped=true"
import script from "./RiskWarning.vue?vue&type=script&lang=js"
export * from "./RiskWarning.vue?vue&type=script&lang=js"
import style0 from "./RiskWarning.vue?vue&type=style&index=0&id=550b7598&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550b7598",
  null
  
)

export default component.exports